import { channelLabelKey, channelSlot } from '../../../lib/contact-rows';
import { Typography } from '../ui';
import { useTranslation } from '../../../lib/i18n';
import styles from './contacts.module.css';

/**
 * The channel a thread went out on, worn as its own colour.
 *
 * Deliberately NOT a DS `<Badge>`: the badge's twelve Styles are statuses and categories, and
 * pressing one of those into service for "this is WhatsApp" would make a channel read as a state.
 * The colour comes from a `data-channel` slot the stylesheet resolves against the accent ramp, so
 * no colour is chosen here and dark mode is the token layer's problem, not this component's.
 *
 * An unknown channel keeps the neutral slot and renders its raw value — the same rule
 * `sourceLabelKey` follows, because the wire field is free text and a fifth channel is one string
 * literal away.
 *
 * Shared by the thread ROW and the thread SCREEN's header so the two cannot disagree about what a
 * thread is called, and mirrored 1:1 by iOS/Android `ChannelChip`.
 *
 * The Inbox card opts into `outlined` — the DS OUTLINE badge (thin border-strong hairline, no fill,
 * primary ink) per Figma `17937:265653` — while the viewer header / thread keep the colour-per-channel
 * fill. A per-call opt-in so only the inbox row diverges.
 */
export function ChannelChip({ channel, outlined = false }: { channel?: string; outlined?: boolean }) {
  const { t } = useTranslation();
  const value = (channel ?? '').trim();
  if (!value) return null;
  const key = channelLabelKey(value);
  return (
    <span className={outlined ? `${styles.channelChip} ${styles.channelChipOutlined}` : styles.channelChip} data-channel={channelSlot(value)}>
      <Typography variant="p3">{key ? t(key) : value}</Typography>
    </span>
  );
}
